import { useSearchParams } from 'react-router-dom';

export const useSearchPageQueryParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const searchTerm = searchParams.get('q') || '';
  const treaties = searchParams.getAll('treaty');
  const page = searchParams.get('page') || '0';
  const from = searchParams.get('from') || undefined;
  const to = searchParams.get('to') || undefined;

  const setSearchTermParam = ({ searchTerm }: { searchTerm: string }) => {
    searchParams.set('q', searchTerm);

    setSearchParams(searchParams, { replace: true });
  };

  const setPageParam = ({ page }: { page: string }) => {
    searchParams.set('page', page);

    setSearchParams(searchParams, { replace: true });
  };

  const setTreatyParam = ({ treaties }: { treaties: string[] }) => {
    searchParams.delete('treaty');

    treaties.forEach((x) => searchParams.append('treaty', x));

    setSearchParams(searchParams, { replace: true });
  };

  const setFromParam = (from?: string) => {
    if (from) {
      searchParams.set('from', from);
    } else {
      searchParams.delete('from');
    }

    setSearchParams(searchParams, { replace: true });
  };

  const setToParam = (to?: string) => {
    if (to) {
      searchParams.set('to', to);
    } else {
      searchParams.delete('to');
    }

    setSearchParams(searchParams, { replace: true });
  };

  return {
    params: {
      treaties,
      searchTerm,
      page,
      from,
      to,
    },
    setSearchTermParam,
    setPageParam,
    setTreatyParam,
    setFromParam,
    setToParam,
  };
};
